export enum LeaderboardType {
	TotalLoyaltyPoints = 'totalLoyaltyPoints',
	RecentLoyaltyPoints = 'recentLoyaltyPoints'
}
